const ROOT = 'User/userList';

export const FETCH_USER_LIST_REQUEST = `${ROOT}/FETCH_USER_LIST_REQUEST`;
export const FETCH_USER_LIST_SUCCESS = `${ROOT}/FETCH_USER_LIST_SUCCESS`;
export const FETCH_USER_LIST_FAILURE = `${ROOT}/FETCH_USER_LIST_FAILURE`;
export const FETCH_REFRESHTOKEN_REQUEST = `${ROOT}/FETCH_REFRESHTOKEN_REQUEST`;
